import React from 'react'

import {
  DropdownItemAnchorStyle,
  DropdownItemNavLinkStyle,
  DropdownItemStyle,
  ListItem,
} from './DropdownItem.styles'
import { ItemProps, ItemAnchorProps, NavLinkProps } from './types'

const DropdownItem = (props: ItemProps) => (
  <ListItem>
    <DropdownItemStyle tabIndex={0} {...props}>
      {props.children}
    </DropdownItemStyle>
  </ListItem>
)

const DropdownItemAnchor = (props: ItemAnchorProps) => (
  <ListItem>
    <DropdownItemAnchorStyle {...props}>
      {props.children}
    </DropdownItemAnchorStyle>
  </ListItem>
)

const DropdownItemNavLink = (props: NavLinkProps) => {
  return (
    <ListItem>
      <DropdownItemNavLinkStyle {...props}>
        {props.children}
      </DropdownItemNavLinkStyle>
    </ListItem>
  )
}

export { DropdownItem, DropdownItemAnchor, DropdownItemNavLink, ListItem }
